import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../shared/store";
import { Loader } from "../../../../shared/ui/Loader";
import { IOffer } from "../../../../shared/store/payment/types";
import { CopyCardDetail } from "../CopyCardDetail";
import styles from "./PaymentOffer.module.scss";
import { Button } from "../../../../shared/ui/Button";
import {
  updateOffer,
  cancelPayment,
} from "../../../../shared/store/payment/api";
import { BANK__ICONS } from "../../../../shared/consts";
import Modal from "../../../../shared/ui/Modal";
import { ChangeSumAlert } from "../ChangeSumAlert";
import { setNoticeShowStatus } from "../../../../shared/store/payment/payment";
import { useAppDispatch } from "../../../../shared/store";
import Exclamation from "../../../../shared/assets/icons/exclamation.svg";
import { startTimer } from "../../../../shared/utils/timer";
import { getPaymentType } from "../../../../shared/utils/cardType";

export type payment = {
  title: string;
  key:
    | "amountFiat"
    | "cardNumber"
    | "cardHolder"
    | "phoneNumber"
    | "bankDetails"
    | "bankHolder";
};

export const PaymentOffer = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const isModalShown = useAppSelector(
    (state) => state.payment.changeAmountNoticeWasShown
  );
  const dispatch = useAppDispatch();
  const [isOpen, setModalStatus] = useState(false);
  const [isPayConfirmOpen, setPayConfirmOpen] = useState(false);

  const close = () => {
    setModalStatus(false);
  };

  const openPayConfirm = () => setPayConfirmOpen(true);
  const closePayConfirm = () => setPayConfirmOpen(false);
  const confirmPay = () => {
    if (offerData) {
      updateOffer(offerData.id);
    }
    closePayConfirm();
  };

  const orderNum = offerData ? <span>{offerData?.humanId}</span> : <Loader />;
  const getProviderIcon = (offer: IOffer) => {
    return BANK__ICONS[offer.providerCode]
      ? BANK__ICONS[offer.providerCode]
      : BANK__ICONS["other"];
  };

  const PAYMENT__DETAIL = [
    {
      title: "Сумма для перевода",
      key: "amountFiat",
    },
    {
      title: "Номер карты для перевода",
      key: "cardNumber",
    },
    {
      title: "Номер телефона для СБП",
      key: "phoneNumber",
    },
    {
      title: "Получатель",
      key: "cardHolder",
    },
    {
      title: "Номер счета",
      key: "bankDetails",
    },
    {
      title: "Получатель",
      key: "bankHolder",
    },
  ] as payment[];

  useEffect(() => {
    if (offerData) {
      const isAmountChange = offerData.amountFiat !== offerData.startAmountFiat;
      if (isModalShown === false && isAmountChange) {
        setModalStatus(true);
        dispatch(setNoticeShowStatus(true));
      }
    }
  }, [offerData]);

  return (
    <>
      <div className={styles.payment}>
        {offerData && offerData.amountFiat !== offerData.startAmountFiat && (
          <div className={styles.change_amount_notif}>
            <img src={Exclamation} alt="" />
            <div className={styles.change_amount_notif_detail}>
              <div className={styles.change_amount_notif_detail_title}>
                Внимание!
              </div>
              <div className={styles.change_amount_notif_detail_description}>
                {`Сумма на оплату изменилась ${offerData.startAmountFiat} → ${offerData.amountFiat}`}
              </div>
            </div>
          </div>
        )}

        <div className={styles.top}>
          <h3 className={styles.title}>Оплата заказа</h3>
          <p className={styles.order_num}>Номер заказа №{orderNum}</p>
        </div>

        {offerData?.isCascade ? (
          <p className={styles.lead}>
            Перейдите на страницу платёжного сервиса для завершения оплаты.
          </p>
        ) : (
          <p className={styles.lead}>
            Переведите точную сумму по реквизитам ниже и нажмите <b>«Я оплатил»</b>.
          </p>
        )}

        <div className={styles.chips}>
          <div className={`${styles.chip} ${styles.chip_green}`}>
            <span className={styles.dot} />
            P2P
          </div>
          <div className={styles.chip}>
            <span className={styles.dot} />
            Один перевод
          </div>
          <div className={styles.chip}>
            <span className={styles.dot} />
            Сохраните чек
          </div>
        </div>

        {/* Direct (P2P) offers display the trader's bank requisites for manual transfer.
            Cascade offers do not — the customer pays through the PSP's hosted page, where the
            PSP shows its own checkout. Showing two parallel "ways to pay" would invite double
            payments and disputes (Baymard checkout research). */}
        {!offerData?.isCascade && (
          <div className={styles.pay_shell}>
            <div className={styles.pay_head}>
              <div className={styles.bank}>
                <div className={styles.bank_icon_wrapper}>
                  {offerData ? (
                    <img
                      src={getProviderIcon(offerData)}
                      alt=""
                      className={styles.bank_icon}
                    />
                  ) : null}
                </div>
                <div className={styles.bank_name}>
                  {offerData?.providerName ?? <Loader />}
                </div>
              </div>
              <div className={styles.card_logo}>
                {offerData?.cardNumber && (
                  <img
                    src={getPaymentType(offerData.cardNumber)}
                    alt="Логотип платежной системы"
                  />
                )}
              </div>
            </div>
            <div className={styles.pay_body}>
              {PAYMENT__DETAIL.map((el, index) => {
                if (
                  !offerData?.cardNumber &&
                  !offerData?.phoneNumber &&
                  el.key === "cardHolder"
                ) {
                  return;
                }
                if (!offerData?.bankDetails && el.key === "bankHolder") {
                  return;
                }
                return (
                  <CopyCardDetail
                    key={index}
                    detailType={el}
                    offerData={offerData}
                  />
                );
              })}
            </div>
          </div>
        )}

        {offerData?.isCascade ? (
          <div className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.num}>1</div>
              <p className={styles.step_text}>Перейдите по ссылке на страницу оплаты</p>
            </div>
            <div className={styles.step}>
              <div className={styles.num}>2</div>
              <p className={styles.step_text}>Оплатите на странице платёжного сервиса</p>
            </div>
            <div className={styles.step}>
              <div className={styles.num}>3</div>
              <p className={styles.step_text}>Дождитесь подтверждения — статус обновится автоматически</p>
            </div>
          </div>
        ) : (
          <div className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.num}>1</div>
              <p className={styles.step_text}>Оплатите из онлайн-банка на точную сумму</p>
            </div>
            <div className={styles.step}>
              <div className={styles.num}>2</div>
              <p className={styles.step_text}>Не разбивайте платеж на несколько переводов</p>
            </div>
            <div className={styles.step}>
              <div className={styles.num}>3</div>
              <p className={styles.step_text}>Сразу после оплаты нажмите «Я оплатил»</p>
            </div>
          </div>
        )}

        <div className={styles.action_row}>
          <div className={styles.timer_box}>
            <div className={styles.timer_label}>Мы ожидаем ваш платеж</div>
            <div className={styles.timer_value}>
              {offerData ? startTimer(offerData.lifeAt) : ""}
            </div>
          </div>
          {/* Cascade offers settle via provider webhook; client-side claim is rejected by backend.
              Same-tab redirect is the Stripe Checkout default — mobile webviews handle `_blank`
              inconsistently (Telegram/bank webviews break tab context). */}
          {offerData?.isCascade ? (
            offerData.paymentLink ? (
              <a
                href={offerData.paymentLink}
                className={`${styles.pay_btn} ${styles.pay_btn_link}`}
              >
                Перейти к оплате
              </a>
            ) : (
              <p className={styles.cascade_link_missing}>
                Не удалось получить ссылку для оплаты. Обратитесь в поддержку.
              </p>
            )
          ) : (
            <Button
              content="Я оплатил"
              className={styles.pay_btn}
              onClick={openPayConfirm}
            />
          )}
        </div>

        {!offerData?.isCascade && (
          <Button
            content="Отменить заявку"
            className={styles.cancel_btn}
            variant="cancel"
            onClick={() => {
              offerData && cancelPayment(offerData.id);
            }}
          />
        )}

        <p className={styles.note}>
          {offerData?.isCascade
            ? "Статус заявки обновится автоматически после оплаты."
            : "Сохраняйте чек до завершения заявки."}
        </p>
      </div>

      {offerData && (
        <Modal isOpen={isOpen} setStatus={close}>
          <ChangeSumAlert offer={offerData} onClick={close} />
        </Modal>
      )}
      <Modal isOpen={isPayConfirmOpen} setStatus={closePayConfirm}>
        <div className={styles.confirm_modal}>
          <h2 className={styles.confirm_title}>Вы уверены, что сделали перевод?</h2>
          <p className={styles.confirm_text}>После нажатия кнопки реквизиты более не будут доступны.</p>
          <div className={styles.confirm_actions}>
            <Button
              content="Назад"
              variant="hollow"
              className={styles.confirm_btn_secondary}
              onClick={closePayConfirm}
            />
            <Button
              content="Подтвердить"
              className={styles.confirm_btn_primary}
              onClick={confirmPay}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
